import { IGetItemChecklistEntregaByIdUseCase } from "../../../presentation/useCases/read/get_item_checklist_entrega_by_id_use_case";
import { ItemChecklistEntrega } from "../../models/item_checklist_entrega";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetItemChecklistEntregaByIdUseCase
 */

export class GetItemChecklistEntregaByIdUseCase implements IGetItemChecklistEntregaByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idItemChecklistEntrega: number): Promise<ItemChecklistEntrega> {
    return this.repository.getItemChecklistEntregaById(idItemChecklistEntrega);
  }
}
